import module from './module.js'

import './components/controller.js'
import './components/conceptos/controller.js'
import './components/conceptos/concepto/controller.js'
import './components/launcher/component.js'
import './components/sumario/controller.js'
import './routes/catalogos.js'
import './routes/catalogos/conceptos.js'
import './routes/catalogos/sumario.js'
import './services/NominasCatalogos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/catalogos/index.js